<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>新建运费模板</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form ref="freightForm" :model="freightForm" label-width="120px">
        <el-form-item label="模板名称：">
          <el-input v-model="freightForm.name" style="width: 220px"></el-input>
        </el-form-item>
        <el-form-item label="配送区域：">
          <div class="frieght-list">
            <div class="list-item">
              <table class="zent-grid-table">
                <thead class="zent-grid-thead">
                  <tr>
                    <th>可配送区域</th>
                    <th></th>
                    <th>首件(个)</th>
                    <th>运费(元)</th>
                    <th>续件(个)</th>
                    <th>续费(元)</th>
                  </tr>
                  <tr
                    v-for="(item, index) in freightList.deliverySettingRuleList"
                    :key="index"
                  >
                    <td>
                      {{ item.addressProvinceName }}
                    </td>
                    <td>
                      <div
                        style="display: flex"
                        v-if="item.addressProvinceName != '默认'"
                      >
                        <el-button type="text" @click="updateTemplate(item, index)"
                          >修改</el-button
                        >
                        <el-button type="text" @click="deleteTemplates(item, index)"
                          >删除</el-button
                        >
                      </div>
                    </td>
                    <td>
                      <el-input type="number" v-model="item.startStandard" />
                    </td>
                    <td>
                      <el-input type="number" v-model="item.startPrice" />
                    </td>
                    <td>
                      <el-input type="number" v-model="item.addStandard" />
                    </td>
                    <td>
                      <el-input type="number" v-model="item.addPrice" />
                    </td>
                  </tr>
                  <tr v-if="freightList.deliverySettingRuleList.length <= 0">
                    <td style="text-align: center">暂无数据</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="">
          <button class="zent-btn-primary zent-btn" @click="chooseArea_andFreight">
            指定可配送区域和运费
          </button>
        </el-form-item>
        <el-form-item label="">
          <div style="display: flex">
            <button class="zent-btn-primary zent-btn" @click="saveTemplate">保存</button>
            <button class="zent-btn-primarys zent-btn" @click="goBack">返回</button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title="选择配送区域"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <span>
        <div class="option-container">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            border
            >全选</el-checkbox
          >
          <el-checkbox-group v-model="checkedAuths" @change="handleCheckedAuthsChange">
            <el-checkbox
              v-for="item in provinceList"
              :label="item.provinceCode"
              :key="item.provinceCode"
              border
              style="margin-top: 10px"
              >{{ item.provincename }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <span class="checked-list">已选择{{ checkedAuths.length || 0 }}个区域</span>
        <el-button
          class="zent-btn-primary zent-btn"
          @click="submit"
          :disabled="checkedAuths.length <= 0"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProvincesAll,
  getDeliverySettingRule,
  addAndUpdateDelivery,
} from "../api/index";
export default {
  data() {
    return {
      freightList: {
        settingName: "",
        deliverySettingRuleList: [],
      },
      freightForm: {
        name: "",
      },
      dialogVisible: false,
      isIndeterminate: false,
      checkAll: false,
      checkedAuths: [],
      provinceList: [],
      status: "",
      provinceList1: [],
      updateIdx: "",
      deleteTemplate: [],
    };
  },
  mounted() {
    var id = sessionStorage.getItem("id");
    if (id) {
      this.getDeliverySettingRule(id);
    } else {
      console.log("新增默认数据");
      this.freightList.deliverySettingRuleList.unshift({
        addPrice: 1,
        addStandard: 1,
        addressProvinceId: "",
        addressProvinceName: "默认",
        createTime: "",
        deliverySettingId: "",
        id: "",
        isDefaultRule: 1,
        isDelete: 0,
        startPrice: 2,
        startStandard: 1,
      });
    }
    this.getProvincesAll();
  },
  computed: {
    authsListOptions() {
      let options = [];
      this.provinceList.forEach((val) => {
        options.push(val.provinceCode);
      });
      return options;
    },
  },
  methods: {
    getDeliverySettingRule(id) {
      getDeliverySettingRule({
        deliverySettingId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.freightList = res.data;
          this.freightForm.name = this.freightList.settingName;
          var bool = this.freightList.deliverySettingRuleList.every((item) => {
            return item.addressProvinceName !== "默认";
          });
          if (bool) {
            console.log("新增默认数据1");
            res.data.deliverySettingRuleList.unshift({
              addPrice: 1,
              addStandard: 1,
              addressProvinceId: "",
              addressProvinceName: "默认",
              createTime: "",
              deliverySettingId: "",
              id: "",
              isDefaultRule: 1,
              isDelete: 0,
              startPrice: 2,
              startStandard: 1,
            });
          }
        } else if (res.code == -1) {
          this.freightList.deliverySettingRuleList = [];
          this.freightForm.name = "";
        }
      });
    },
    getProvincesAll() {
      getProvincesAll().then((res) => {
        if (res.code == 1) {
          this.provinceList = res.data;
          this.provinceList1 = JSON.parse(JSON.stringify(res.data));
        }
        if (res.code == -1) {
          this.provinceList = [];
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleCheckedAuthsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.provinceList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.provinceList.length;
    },
    handleCheckAllChange(val) {
      this.checkedAuths = val ? this.authsListOptions : [];
      this.isIndeterminate = false;
    },
    submit() {
      console.log(this.checkedAuths, this.provinceList, "提交");
      let str = "";
      let ids = "";
      this.provinceList.forEach((item) => {
        if (~this.checkedAuths.indexOf(item.provinceCode)) {
          str += `${"," + item.provincename}`;
          ids += `${"," + item.provinceCode}`;
          if (str.substr(0, 1) == ",") str = str.substr(1);
          if (ids.substr(0, 1) == ",") ids = ids.substr(1);
        }
      });
      this.dialogVisible = false;
      if (this.status == "update" && this.updateIdx >= 0) {
        console.log(this.updateIdx, "updateIdx");
        console.log(str, ids, "ids");
        this.freightList.deliverySettingRuleList[
          this.updateIdx
        ].addressProvinceName = str;
        this.freightList.deliverySettingRuleList[this.updateIdx].addressProvinceId = ids;
        console.log(this.freightList);
        this.status = "";
        return;
      }
      console.log(1111);
      this.freightList.deliverySettingRuleList.push({
        addPrice: 1,
        addStandard: 1,
        addressProvinceId: ids,
        addressProvinceName: str,
        createTime: "",
        deliverySettingId: "",
        id: "",
        isDefaultRule: 1,
        isDelete: 0,
        startPrice: 2,
        startStandard: 1,
      });
      this.checkedAuths = [];
    },
    chooseArea_andFreight() {
      console.log(this.freightList, "freightList");
      let str = this.freightList.deliverySettingRuleList
        .map((item) => item.addressProvinceId)
        .join(",");
      if (str.substr(0, 1) == ",") str = str.substr(1);
      let ids = [];
      ids = str.split(",");
      ids.forEach((ele) => {
        this.provinceList.forEach((item, index) => {
          if (item.provinceCode == ele) {
            this.provinceList.splice(index, 1);
          }
        });
      });
      this.dialogVisible = true;
    },
    saveTemplate() {
      this.freightList.settingName = this.freightForm.name;
      console.log(
        this.freightList,
        this.freightList.deliverySettingRuleList,
        this.freightForm.name
      );
      if (!this.freightList.settingName) {
        this.$notify({
          title: "警告",
          message: "模板名称不能为空~",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      this.freightList.deliverySettingRuleList.forEach((item) => {
        item.deliverySettingId = this.freightList.id || null;
        if (item.addressProvinceId != "") {
          item.isDefaultRule = 0;
        } else {
          item.isDefaultRule = 1;
        }
      });
      this.deleteTemplate.forEach((item) => {
        this.freightList.deliverySettingRuleList.push(item);
      });
      console.log(this.freightList, "this.freightList");
      addAndUpdateDelivery({
        deliverySettingId: this.freightList.id,
        settingName: this.freightList.settingName,
        consumeMethod: 2,
        deliveryMethod: 2,
        isFreeDelivery: 0,
        valuationType: 1,
        indexNo: 1,
        isEnable: 1,
        deliverySettingRule: JSON.stringify(this.freightList.deliverySettingRuleList),
      }).then((res) => {
        if (res.code == 1) {
          this.deleteTemplate = [];
          this.goBack();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    updateTemplate(item, index) {
      this.updateIdx = index;
      var provinceList = this.provinceList1;
      this.status = "update";
      console.log(item, this.provinceList);
      console.log(this.freightList, "freightList");
      let str = item.addressProvinceId;
      let str1 = this.freightList.deliverySettingRuleList
        .map((item) => item.addressProvinceId)
        .join(",");
      console.log(str, str1);
      if (str.substr(0, 1) == ",") str = str.substr(1);
      if (str1.substr(0, 1) == ",") str1 = str1.substr(1);
      var checkedAuths = str1.split(",");
      var strArr = str.split(",");
      console.log(checkedAuths, "checkedAuths", strArr, "strArr");
      for (let i in checkedAuths) {
        checkedAuths[i] = Number(checkedAuths[i]);
      }
      this.checkedAuths = checkedAuths;
      console.log(this.checkedAuths, "this.checkedAuths1");
      this.checkedAuths.forEach((ele) => {
        this.provinceList.forEach((item, index) => {
          if (item.provinceCode == ele) {
            this.provinceList.splice(index, 1);
            this.checkedAuths = [];
          }
        });
      });
      console.log(provinceList, "this.provinceList2");
      let newArr = [];
      strArr.forEach((item, index) => {
        provinceList.forEach((ele, index) => {
          if (ele.provinceCode == item) {
            newArr.push(provinceList[index]);
          }
        });
      });
      console.log(newArr, "newArr");
      this.provinceList = [...this.provinceList, ...newArr];
      console.log(this.provinceList, "新的this.provinceList");
      console.log(this.checkedAuths, "this.checkedAuths2");
      strArr.forEach((item, index) => {
        this.checkedAuths.push(item);
      });
      console.log(this.checkedAuths, "新的this.checkedAuths2");
      this.dialogVisible = true;
    },
    deleteTemplates(item, index) {
      console.log(item, index);
      this.$confirm("此操作将永久删除, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        this.freightList.deliverySettingRuleList.splice(index, 1);
        if (item.id) {
          item.isDelete = 1;
          this.deleteTemplate.push(item);
        }
        this.$notify({
          title: "提示",
          message: "删除成功",
          type: "success",
          duration: 1000,
        });
      });
    },
    goBack() {
      this.$router.push("/setting/freight");
      sessionStorage.removeItem("id");
    },
  },
};
</script>

<style lang="less" scoped>
.checked-list {
  font-size: 12px;
  color: #9f9f9f;
  margin-right: 10px;
}
.option-container {
  padding: 20px;
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0;
  }
  .el-checkbox-group {
    margin: 15px 0;
  }
}
.zent-btn-primary {
  border-color: var(--theme-primary-4, #155bd4);
  background-color: var(--theme-primary-4, #155bd4);
}
.zent-btn-primarys {
  border-color: var(--theme-primary-4, #155bd4) !important;
  color: var(--theme-primary-4, #155bd4) !important;
  background-color: #fff;
  margin-left: 15px;
}
button {
  appearance: none;
  border: none;
  background-color: transparent;
  outline: none;
}
.zent-btn {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding: 0 16px;
  border-radius: 2px;
  font-family: inherit;
  border: 1px solid #dcdee0;
  text-align: center;
  vertical-align: middle;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.3s;
  color: #fff;
}
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 20px;
    .frieght-list {
      width: calc(100vw - 360px);
      height: auto;
      max-height: calc(100vh - 320px);
      overflow-y: scroll;
      .list-item {
        .zent-grid-table {
          width: 100%;
          text-align: left;
          border-collapse: collapse;
          border-spacing: 0;
          .zent-grid-thead {
            width: 100%;
            tr {
              display: table-row;
              background-color: var(--theme-stroke-9, #fff);
              height: 56px;
              line-height: 56px;
              color: var(--theme-stroke-1, #323233);
              border-bottom: 1px solid #ebedf0;
              border-bottom-color: var(--theme-stroke-6, #ebedf0);
              th {
                font-size: 14px;
                display: table-cell;
                box-sizing: border-box;
                border-bottom: 1px solid #ebedf0;
                border-bottom-color: var(--theme-stroke-6, #ebedf0);
                vertical-align: middle;
                text-align: right;
                background: #f7f8fa;
                padding-right: 30px;
                &:first-child {
                  text-align: left;
                  padding-left: 18px;
                  width: 60%;
                }
              }
              td {
                padding: 0 18px;
                text-align: right;
                &:first-child {
                  text-align: left;
                }
              }
            }
          }
        }
      }
    }
  }
}
/deep/ .el-input {
  width: 76%;
}
</style>
